export enum OnboardingMode {
  AWS = 'backup_ub_aws',
  Wasabi = 'backup_ub_wasabi',
  AppsAWS = 'apps_ub_aws',
  AppsWasabi = 'apps_ub_wasabi',
  RA = 'remote_desktop',
  Rmm = 'rmm',
  SkipWizard = 'skipWizard',
  B2 = 'b2_only',
  RmmScripts = 'rmm_script_library'
}
